var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "col-12" }, [
    _c(
      "div",
      {
        staticClass: "annotations-side-card",
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.onSelect.apply(null, arguments)
          },
          mouseenter: function ($event) {
            return _vm.onGeometryHighlight(_vm.rid)
          },
          mouseleave: function ($event) {
            return _vm.onGeometryHighlight(_vm.rid, false)
          },
        },
      },
      [
        _c("div", { staticClass: "annotations-side-card__wrapper" }, [
          _c(
            "div",
            { staticClass: "annotations-side-card__wrapper__container" },
            [
              _c("div", { staticClass: "side-card-content" }, [
                _c(
                  "div",
                  { staticClass: "side-card-content__left-container" },
                  [
                    _c("div", { staticClass: "side-card-info" }, [
                      _c("div", { staticClass: "side-card-info__title" }, [
                        _c("span", [_vm._v(_vm._s(_vm.title))]),
                      ]),
                      _vm._v(" "),
                      _vm.description
                        ? _c("div", { staticClass: "side-card-info__desc" }, [
                            _c("span", [
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.description),
                                },
                              }),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "side-card-content__right-container" },
                  [
                    _c("div", { staticClass: "side-card-tool text-center" }, [
                      _c("div", { staticClass: "btn-group my-0" }, [
                        _vm.zoomToCollection
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-sm min-w-auto btn-add",
                                attrs: {
                                  type: "button",
                                  "data-toggle": "tooltip-city",
                                  title: "Zoom para Anotação",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.onZoomTo.apply(null, arguments)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fas fa-search-location",
                                }),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showHideCollection
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-sm min-w-auto btn-add",
                                attrs: {
                                  type: "button",
                                  "data-toggle": "tooltip-city",
                                  title: _vm.visibility
                                    ? "Esconder Anotação"
                                    : "Mostrar Anotação",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.onToogleVisibility.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fas",
                                  class: [
                                    _vm.visibility ? "fa-eye" : "fa-eye-slash",
                                  ],
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }